import {connect} from "react-redux";
import DetalhamentoPagamentosSLC from "./pagamentos";

export default connect()(DetalhamentoPagamentosSLC)
